import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SdsDialogConfig } from '@gsa-sam/components';
import { SdsFiltersComponent } from '@gsa-sam/sam-formly';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { BehaviorSubject } from 'rxjs';
import { RequestedByDomainOptions } from '../request.config';

@Component({
  selector: 'sam-frontend-request-side-nav',
  templateUrl: './request-side-nav.component.html',
  styleUrls: ['./request-side-nav.component.css'],
})
export class RequestSideNavComponent implements OnInit, AfterViewInit {
  model: any = {};
  filterComponent: SdsFiltersComponent;
  @Input() filter: any;
  @Input() fields1: FormlyFieldConfig[];
  @Output() filterEvent = new EventEmitter<any>();
  @ViewChild('filters') set updateFilterComponent(comp: SdsFiltersComponent) {
    if (comp) {
      this.filterComponent = comp;
    }
  }
  public filterChange$ = new BehaviorSubject<object>([]);
  requestLinks: any = [
    { id: '2', text: 'Inbox' },
    { id: '1', text: 'Sent' },
  ];
  responsiveDialogOptions: SdsDialogConfig = {
    ariaLabel: 'Search Filters',
  };

  constructor() {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }
  ngOnInit(): void {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }

  ngAfterViewInit() {
    this.filterChange$.subscribe((res) => {
      // This is intentional
    });
  }

  filterChange(): void {
    this.filter = this.model;
    this.filter['reqStatusIds'] =
      this.model.reqStatus && this.model.reqStatus.reqStatusCheckbox
        ? this.getRequestStatus(this.model)
        : '';
    this.filter['reqTypeIds'] =
      this.model.reqType && Object.keys(this.model.reqType).length
        ? this.getRequestTypes(this.model)
        : '';
    this.filter['reqByQuery'] = this.getRequestedBy(this.model);
    this.filter['resByQuery'] = this.getRespondedBy(this.model);
    this.filter['agencyPicker'] = this.getAgencyPicker(this.model);
    this.filter['keyword'] = this.getKeywordUpdated(this.model);
    this.filterEvent.emit(this.filter);
  }

  checkAndDiableOrEnableRequestDomain = (domainKeys: any[]) => {

    if (this.filterComponent?.fields?.length) {
      this.fields1 = this.fields1.map((eachField: FormlyFieldConfig) => {
        if (eachField.key === 'reqByDomain') {
          eachField = this.filteredConfDomains(eachField, domainKeys);
        }
        return eachField;
      });
    }
  }
  filteredConfDomains(eachField: FormlyFieldConfig, domainKeys): FormlyFieldConfig {
    const isRequestRoleChecked =
      this.filterComponent?.model?.reqType?.administration['1'] || false;
    if (isRequestRoleChecked && domainKeys?.length) {
    const options = JSON.parse(JSON.stringify(RequestedByDomainOptions))
        .filter(
          (eachOption: any) => domainKeys.indexOf(eachOption.value) >= 0
        )
        ?.sort((obj1: any, obj2: any) => {
          const label1 = obj1.label.toLowerCase();
          const label2 = obj2.label.toLowerCase();
          if(label1 < label2) return -1;
          return label1 > label2 ? 1 : 0;
        });
      const defaultValue = {};
      options.forEach((eachOption: any) => {
        defaultValue[+eachOption.value] = false;
      });

      eachField.props = {
        label: 'Requests By Domain',
        group: 'accordion',
      };
      eachField.fieldGroup = [
        {
          key: 'reqByDomainCheckbox',
          type: 'multicheckbox',
          defaultValue,
          props: {
            hideOptional: true,
            options,
          },
        },
      ];
    } else {
      if (eachField?.fieldGroup[0]?.defaultValue) {
        eachField?.formControl
          ?.get('reqByDomainCheckbox')
          ?.patchValue(eachField.fieldGroup[0].defaultValue);
      }
      eachField.props = {};
      eachField.fieldGroup = [];
     this.model.reqByDomain.reqByDomainCheckbox = {}
    }
    return eachField;
  }

  getKeywordUpdated(data: any) {
    let keyword: any = [];
    if (!data.keyword || data.keyword.length == 0) {
      return data.keyword;
    }
    for (let each of data.keyword) {
      let keys: any = each.key.split(',');
      if (!keys[1]) {
        each.key = each.key.trim().replace(',', '');
        each.text = each.text.trim().replace(',', '');
      }
      keyword.push(each);
    }
    return keyword;
  }

  getAgencyPicker(data: any) {
    const agency = [];
    if (data.agencyPicker && data.agencyPicker.length) {
      for (const [value, label] of Object.entries(data.agencyPicker)) {
        if (value) {
          agency.push(label);
        }
      }
    }
    return agency;
  }

  getRespondedBy(data: any): string {
    const resBy = [];
    if (data.respondedBy && data.respondedBy.length) {
      data.respondedBy.forEach((v) => {
        resBy.push(v.text);
      });
    }
    return resBy.join(',');
  }

  getRequestedBy(data: any): string {
    const reqBy = [];

    if (data.requestedBy && data.requestedBy.length) {
      data.requestedBy.forEach((v) => {
        reqBy.push(v.text);
      });
    }
    return reqBy.join(',');
  }

  getRequestTypes(data: any): string {
    const reqTypeIds = [];
    for (const [, mLabel] of Object.entries(data.reqType)) {
      for (const [cValue, cLabel] of Object.entries(mLabel || {})) {
        if (cLabel) {
          reqTypeIds.push(cValue);
        }
      }
    }
    return reqTypeIds.join(',');
  }

  getRequestStatus(data: any): string {
    const reqStatusIds = [];
    for (const [value, label] of Object.entries(data.reqStatus.reqStatusCheckbox)) {
      if (label) {
        reqStatusIds.push(value);
      }
    }

    return reqStatusIds.join(',');
  }

  onSubPanelClicked($event) {
    this.filter = this.model;
    this.filter['feedTypeId'] = $event.id;
    this.filterEvent.emit(this.filter);
  }
}
